module.exports = __webpack_public_path__ + "static/media/expanding_green.c67b9676.png";